import { useRef, useEffect } from "react";
import { MessageBubble } from "./MessageBubble";
import { type Conversation } from "@/hooks/useChat";

interface ChatCanvasProps {
  conversation: Conversation;
  isStreaming: boolean;
}

export function ChatCanvas({ conversation, isStreaming }: ChatCanvasProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversation.messages, conversation.messages[conversation.messages.length - 1]?.content]);

  return (
    <div className="flex-1 overflow-y-auto scrollbar-thin">
      <div className="max-w-3xl mx-auto py-6 space-y-1">
        {conversation.messages.map((msg, idx) => (
          <MessageBubble
            key={msg.id}
            message={msg}
            isStreaming={
              isStreaming &&
              idx === conversation.messages.length - 1 &&
              msg.role === "assistant"
            }
          />
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
